import UniDateRangePicker from './UniDateRangePicker.vue'
export default UniDateRangePicker



// WEBPACK FOOTER //
// ./src/components/uniWidgets/UniDateRangePicker/index.js